import { api } from "@/lib/apiClient";

export interface EmployeeHrProfile {
  user_login: string;
  user_display: string | null;
  entry_date: string | null;
  updated_at: string | null;
  updated_by_login: string | null;
}

export function getEmployeeHrProfile(userLogin: string): Promise<EmployeeHrProfile> {
  return api.get(`/employee-times/hr-profiles/${encodeURIComponent(userLogin)}`);
}

export function upsertEmployeeHrProfile(
  userLogin: string,
  payload: { entry_date: string | null; user_display?: string },
): Promise<EmployeeHrProfile> {
  return api.put(`/employee-times/hr-profiles/${encodeURIComponent(userLogin)}`, payload);
}
